'use client'

import React from 'react'
import {
  CustomerContentType,
  CustomerProductGroupPageFragment,
  CustomerStartPageFragment,
} from '@contentsite/src/graphql/generated/graphql-types'
import { ProductListByIds } from '@dustin-web/product-components/src/product-list-by-ids'
import CustomerNavigation from '../customer/customer-navigation'
import { CategoryLinkBoxes } from '../customer/category-link-boxes'
import { GenericLinkBoxes } from '../customer/generic-link-boxes'

const Customer = (props: {
  page: CustomerStartPageFragment | CustomerProductGroupPageFragment
}) => {
  const page = props.page

  const header = (page as CustomerProductGroupPageFragment)?.header
  return (
    <div className="container u-py-24">
      <div className="row">
        <div className="col-12 order-2 order-lg-1 col-lg-4 col-xl-3">
          {page.customerNavigation && <CustomerNavigation navigation={page.customerNavigation} />}
        </div>
        <div className="col-12 order-1 order-lg-2 col-lg-8 col-xl-9">
          {header && <h1 className="h2">{header}</h1>}
          {page.content.map((content, index) => {
            if (content.type === CustomerContentType.Text) {
              return (
                <div
                  className="c-customer-content"
                  key={index}
                  dangerouslySetInnerHTML={{ __html: content.textContent ?? '' }}></div>
              )
            } else if (content.type === CustomerContentType.ProductList) {
              return (
                <div key={index} className="u-mb-24">
                  {content.listProductIds && (
                    <ProductBoxes
                      productErpIdentifiers={content.listProductIds}
                      displayAsList={content.displayAsList}
                    />
                  )}
                </div>
              )
            } else if (content.type === CustomerContentType.ProductGrouping) {
              return (
                <div key={index}>
                  {content.groupDisplayName && (
                    <h2 className="h3" id={content.groupDisplayName}>
                      {content.groupDisplayName}
                    </h2>
                  )}
                  {content.groupProductLists?.map((productList, index) => {
                    return (
                      <div key={index} className="u-mb-24">
                        <ProductBoxes
                          productErpIdentifiers={productList.productIds}
                          displayAsList={productList.displayAsList}
                        />
                      </div>
                    )
                  })}
                </div>
              )
            } else if (content.type === CustomerContentType.LinkBoxes) {
              return <GenericLinkBoxes key={index} linkBoxes={content.linkBoxes ?? []} />
            } else if (content.type === CustomerContentType.CategoryLinkBoxes) {
              return <CategoryLinkBoxes key={index} categoryPaths={content.categoryPaths ?? []} />
            }

            return <></>
          })}
        </div>
      </div>
    </div>
  )
}

const ProductBoxes = ({
  productErpIdentifiers,
  displayAsList,
}: {
  productErpIdentifiers: string[]
  displayAsList: boolean
}) => {
  return displayAsList ? (
    <ProductListByIds
      productErpIdentifiers={productErpIdentifiers}
      listType={'extended'}
      digitalDataOrigin={'customerLandingPage'}
    />
  ) : (
    <ProductListByIds
      productErpIdentifiers={productErpIdentifiers}
      listType={'gallery'}
      gallerySizeClasses="col-12 col-sm-6 col-md-4"
      digitalDataOrigin={'customerLandingPage'}
    />
  )
}

export default Customer
